import { call, put, takeLatest } from 'redux-saga/effects';

import { history } from '@utils/history';
import { CarQuote } from '@models/CarQuote';
import { CarQuoteApi } from '@apis/CarQuoteApi';
import { SagaPayload } from '@utils/typescript';
import { routeCarQuotePaymentPage } from '@components/CarQuotePaymentPage';

import {
  carQuoteFind,
  CarQuoteFindPayload,
  carQuoteCreate,
  CarQuoteCreatePayload,
  carQuoteFetch,
  CarQuoteFetchPayload,
  carQuoteUpdate,
  CarQuoteUpdatePayload,
  carQuoteReset,
  CarQuoteResetPayload,
  carQuoteCustom,
  CarQuoteCustomPayload,
  carQuoteLock,
  CarQuoteLockPayload,
  carQuotePayByCash,
  CarQuotePayByCashPayload,
  carQuotePay,
  CarQuotePayPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';
import { routeCarQuoteBuyReviewPage } from './route';
import { BillingApi } from '@apis/BillingApi';
import { Billing } from '@models/Billing';

function* handleCarQuoteFind({ payload }: SagaPayload<CarQuoteFindPayload>) {
  const state: StateUpdatePayload = { carQuote: null };
  try {
    state.carQuote = (yield call(CarQuoteApi.find, payload)) as CarQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleCarQuoteCreate({ payload }: SagaPayload<CarQuoteCreatePayload>) {
  const state: StateUpdatePayload = { carQuote: null };
  try {
    state.carQuote = (yield call(CarQuoteApi.create, payload)) as CarQuote;
    yield put(stateUpdate(state));
    history.navigate(routeCarQuoteBuyReviewPage({ orderNumber: state.carQuote.orderNumber }));
  } catch { }
}

function* handleCarQuoteFetch({ payload }: SagaPayload<CarQuoteFetchPayload>) {
  const state: StateUpdatePayload = { carQuote: null };
  try {
    state.carQuote = (yield call(CarQuoteApi.get, payload)) as CarQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleCarQuoteUpdate({ payload }: SagaPayload<CarQuoteUpdatePayload>) {
  const state: StateUpdatePayload = { carQuote: null };
  try {
    state.carQuote = (yield call(CarQuoteApi.update, payload)) as CarQuote;
    yield put(stateUpdate(state));
    history.navigate(routeCarQuoteBuyReviewPage({ orderNumber: state.carQuote.orderNumber }));
  } catch { }
}

function* handleCarQuoteReset({ payload }: SagaPayload<CarQuoteResetPayload>) {
  try {
    yield call(CarQuoteApi.reset, payload);
    history.navigate(routeCarQuoteBuyReviewPage({ orderNumber: payload.orderNumber }));
  } catch { }
}

function* handleCarQuoteCustom({ payload }: SagaPayload<CarQuoteCustomPayload>) {
  try {
    yield call(CarQuoteApi.custom, payload);
    history.navigate(routeCarQuoteBuyReviewPage({ orderNumber: payload.orderNumber }));
  } catch { }
}

function* handleCarQuoteLock({ payload }: SagaPayload<CarQuoteLockPayload>) {
  try {
    yield call(CarQuoteApi.lock, payload);
    history.navigate(routeCarQuoteBuyReviewPage({ orderNumber: payload.orderNumber }));
  } catch { }
}

function* handleCarQuotePayByCash({ payload }: SagaPayload<CarQuotePayByCashPayload>) {
  try {
    yield call(CarQuoteApi.payByCash, payload);
    history.navigate(routeCarQuoteBuyReviewPage({ orderNumber: payload.orderNumber }));
  } catch { }
}

function* handleOrderCreate({ payload }: SagaPayload<CarQuotePayPayload>) {
  try {
    const { id } = (yield call(BillingApi.create, payload)) as Billing;
    history.navigate(routeCarQuotePaymentPage({ orderNumber: payload.orderNumber, billingId: id }));
  } catch { }
}

export default function* () {
  yield takeLatest(carQuoteFind, handleCarQuoteFind);
  yield takeLatest(carQuoteCreate, handleCarQuoteCreate);
  yield takeLatest(carQuoteFetch, handleCarQuoteFetch);
  yield takeLatest(carQuoteUpdate, handleCarQuoteUpdate);
  yield takeLatest(carQuoteReset, handleCarQuoteReset);
  yield takeLatest(carQuoteCustom, handleCarQuoteCustom);
  yield takeLatest(carQuoteLock, handleCarQuoteLock);
  yield takeLatest(carQuotePayByCash, handleCarQuotePayByCash);
  yield takeLatest(carQuotePay, handleOrderCreate);
}
